import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { showToast } from '../../../services';
import { userActions } from '../../../actions';
import { profileActions } from '../../../actions';
import { useLoggedUser } from '../../../hooks/useLoggedUser';

import leftArrow from '../../../assets/img/left-arrow.svg';
import rightArrow from '../../../assets/img/right-arrow.svg';

const FavoriteActivities = () => {
    const [activities, setActivities] = useState([]);
    const [selectedActivities, setSelectedActivities] = useState([]);
    const dispatch = useDispatch();
    const history = useHistory();
    const loggedUser = useLoggedUser();

    if (!loggedUser?.data?.StudentProfileID) {
        history.replace('/login');
        return null;
    }
    const { loading } = useSelector((state) => state.myprofile);

    // Redirect to /home if student already registered
    useEffect(() => {
        if (loggedUser && loggedUser.data.LoggedInStatus === "Y") {
            history.push('/');
        }
    }, [history, loggedUser]);

    useEffect(() => {
        if (loggedUser) {
            fetchFavActivities();
        }
    }, [dispatch, loggedUser]);

    // Fetch user profile and preselect activities
    useEffect(() => {
        if (loggedUser?.data?.StudentProfileID) {
            dispatch(profileActions.fetchMyprofile(loggedUser.data.StudentProfileID))
                .then((profile) => {
                    const favoriteActivities = Array.isArray(profile?.[0]?.FavoriteString)
                        ? profile[0].FavoriteString
                        : [];

                    setSelectedActivities(
                        favoriteActivities.map(fav => ({
                            ActivityID: fav.ActivityID,
                            ActivityName: fav.ActivityName
                        }))
                    );
                })
                .catch((error) => {
                    showToast(error.toString(), 'error');
                });
        }
    }, [dispatch, loggedUser?.data?.StudentProfileID]);

    const fetchFavActivities = () => {
        dispatch(userActions.fetchFavActivities())
            .then(response => {
                if (response) {
                    setActivities(response);
                } else {
                    setActivities([]);
                }
            })
            .catch(error => {
                showToast(error.toString(), 'error');
                setActivities([]);
            });
    };

    const handleClick = (ActivityID, ActivityName) => {
        // Toggle the selected activity
        setSelectedActivities(prevSelectedActivities => {
            if (prevSelectedActivities.some(activity => activity.ActivityID === ActivityID)) {
                // If the activity is already selected, remove it from the array
                return prevSelectedActivities.filter(activity => activity.ActivityID !== ActivityID);
            } else {
                // Otherwise, add it to the array
                return [...prevSelectedActivities, { ActivityID, ActivityName }];
            }
        });
    };

    const goBack = (event) => {
        event.preventDefault();
        history.push('/register');
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (selectedActivities && selectedActivities.length > 0) {
            const formData = {
                StudentProfileID: loggedUser.data.StudentProfileID,
                FavoriteString: selectedActivities
            };

            dispatch(userActions.updatefavactivity(formData))
                .then(response => {
                    if (response) {
                        history.push('/termsandconditions');
                        // showToast('Favorite activities updated successfully', 'success');
                    }
                })
                .catch(error => {
                    showToast(error.toString(), 'error');
                });
        } else {
            history.push('/termsandconditions');
        }
    };

    return (
        <React.Fragment>
            <div className="continer-fluid terms-page">
                <nav className="navbar navbar-expand-sm">
                    <div className="container-fluid">
                        <a className="navbar-brand">
                            <div className="w-20 d-flex align-items-center justify-content-center">
                                {/* <img className="w-100" src={menuIcon} alt="Menu Icon" /> */}
                            </div>
                        </a>
                        <div className="collapse navbar-collapse" id="mynavbar">
                            <ul className="navbar-nav me-auto"></ul>
                            <form className="d-flex justify-content-end">
                                {/* <img className="w-100" src={questionIcon} alt="Question Icon" /> */}
                            </form>
                        </div>
                    </div>
                </nav>

                <div className="content" id="content">
                    <div className="d-flex justify-content-center align-items-center flex-column">
                        <h2 className="b-font main-heading-top activities-h">What are your Favourite Activities</h2>
                        <div className="activity-cont">
                            <div className="row checkbox-div mb-5">
                                {loading ? null : (
                                    activities && activities.length > 0 ? (
                                        activities
                                            .filter(activity => activity.EnabledFlag === "Y")
                                            .map((activity) => (
                                                <div key={activity.ActivityID} className="col-lg-4 col-md-4 col-sm-4 mb-4">
                                                    <label className="checkbox-btn">
                                                        <input
                                                            type="checkbox"
                                                            onChange={() => handleClick(activity.ActivityID, activity.ActivityName)}
                                                            checked={selectedActivities.some(selected => selected.ActivityID === activity.ActivityID)}
                                                        />
                                                        <span></span>
                                                        <label className='pl-4'>
                                                            {activity.ActivityName}
                                                        </label>
                                                    </label>
                                                </div>
                                            ))
                                    ) : (
                                        <div>No Activity available</div>
                                    )
                                )}
                            </div>

                        </div>
                    </div>

                    <div className="btm-butons">
                        <div className="d-flex w-100 justify-content-between">
                            <button className="arrow-btns" onClick={goBack}>
                                <img src={leftArrow} className="w-100" alt="Left Arrow" />
                            </button>
                            <button className="arrow-btns" onClick={handleSubmit}>
                                <img src={rightArrow} className="w-100" alt="Right Arrow" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default FavoriteActivities;
